module.exports = __webpack_public_path__ + "img/album07_34.fef223f8.jpg";